import React from 'react';
import { prettifyDate } from 'lib/dateUtilities';

function JoinedDate({ date }) {
    return (
        <p className="mt-2 text-base text-gray-mid">
            <i className="fa-solid fa-calendar-days"></i>
            <span className="ml-2">Joined {prettifyDate(date, false)}</span>
        </p>
    );
}

export default JoinedDate;
